import styled from '../../styled-components';

export const StyledTextArea = styled.textarea`
  margin-bottom: 25px;
  width: 90%;
  height: 300px;
  border: none;
  resize: none;
`;
